(() => {
  const config = document.getElementById('V2Config');
  if (!config) return;
  const cfg = JSON.parse(config.textContent);
  const bag = document.getElementById('BagDialog');
  const status = document.getElementById('LiveStatus');
  const dialogs = new WeakSet();
  const closingDialogs = new WeakMap();
  const selections = new WeakMap();
  const disabledControls = new WeakMap();
  const galleryFades = new WeakMap();
  let scrollLock, cartBusy = false, quickRequest, stickyObserver, headerObserver, frame, cartRenderVersion = 0;
  const reduceMotion = () => matchMedia('(prefers-reduced-motion:reduce)').matches;
  const openDialogs = () => [...document.querySelectorAll('dialog[open]')];
  const message = text => { if (status) status.textContent = text; };

  function viewport() {
    const view = window.visualViewport;
    for (const dialog of openDialogs()) {
      dialog.style.setProperty('--dialog-height', `${view?.height || innerHeight}px`);
      dialog.style.setProperty('--dialog-top', `${view?.offsetTop || 0}px`);
    }
  }
  function lockScroll() {
    if (scrollLock) return;
    scrollLock = { y: scrollY, body: document.body.style.cssText, html: document.documentElement.style.overflow };
    document.documentElement.style.overflow = 'hidden';
    Object.assign(document.body.style, { position: 'fixed', top: `-${scrollLock.y}px`, left: '0', right: '0', overflow: 'hidden' });
  }
  function releaseScroll() {
    if (!scrollLock || openDialogs().length) return;
    const saved = scrollLock;
    scrollLock = undefined;
    document.body.style.cssText = saved.body;
    document.documentElement.style.overflow = saved.html;
    window.scrollTo({ top: saved.y, behavior: 'instant' });
  }
  function initDialog(dialog) {
    if (dialogs.has(dialog)) return;
    dialogs.add(dialog);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(dialog); });
    dialog.addEventListener('close', () => { releaseScroll(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(dialog);
    });
  }
  function open(dialog, returnFocus = document.activeElement) {
    if (!dialog) return;
    initDialog(dialog);
    if (closingDialogs.has(dialog)) {
      closingDialogs.delete(dialog);
      window.NuzzlinoMotion?.cancel(dialog);
    }
    if (dialog.open) return;
    dialog.returnFocus = returnFocus;
    lockScroll();
    dialog.showModal();
    viewport();
    (dialog.querySelector('input[type=search]') || dialog.querySelector('[data-close]'))?.focus({ preventScroll: true });
    window.NuzzlinoMotion?.open(dialog);
  }
  function close(dialog, immediate = false) {
    if (!dialog?.open) return Promise.resolve();
    const pending = closingDialogs.get(dialog);
    if (pending && !immediate) return pending.promise;
    const finish = () => {
      dialog.close();
      document.querySelectorAll('[data-open-dialog]').forEach(control => { if (control.dataset.openDialog === dialog.id) control.setAttribute('aria-expanded', 'false'); });
      releaseScroll();
      if (!openDialogs().length && dialog.returnFocus?.isConnected) dialog.returnFocus.focus({ preventScroll: true });
    };
    if (immediate || reduceMotion() || !window.NuzzlinoMotion) {
      closingDialogs.delete(dialog);
      window.NuzzlinoMotion?.cancel(dialog);
      finish();
      return Promise.resolve();
    }
    const state = {};
    closingDialogs.set(dialog, state);
    state.promise = window.NuzzlinoMotion.exit(dialog).then(() => {
      if (closingDialogs.get(dialog) !== state) return;
      closingDialogs.delete(dialog);
      finish();
    });
    return state.promise;
  }
  function report(scope, text) {
    const error = scope?.isConnected && scope.querySelector('.form-error');
    if (error) { error.textContent = text; error.hidden = false; }
    message(text);
  }
  function setCartBusy(value) {
    cartBusy = value;
    document.querySelectorAll('.cart-form').forEach(form => {
      form.setAttribute('aria-busy', String(value));
      form.querySelectorAll('button,input,textarea').forEach(control => {
        if (value) { disabledControls.set(control, control.disabled); control.disabled = true; }
        else if (disabledControls.has(control)) { control.disabled = disabledControls.get(control); disabledControls.delete(control); }
      });
    });
  }
  function quantity(input, value, allowRemove = false) {
    const min = Number(input.min) || 1, step = Number(input.step) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    if (allowRemove && value <= 0) return 0;
    const upper = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
    return Math.min(upper, min + Math.max(0, Math.ceil((value - min) / step)) * step);
  }
  async function cartRequest(path, body) {
    const response = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const result = await response.json();
    if (!response.ok) throw Error(result.description || result.message || cfg.error);
    return result;
  }
  async function getBag(focus) {
    const url = new URL(cfg.cart, location.origin);
    url.searchParams.set('section_id', 'v2-cart');
    cartRenderVersion += 1;
    const [response, cartState] = await Promise.all([fetch(url), readDiscountCart()]);
    if (!response.ok) throw Error(cfg.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = doc.querySelector('.cart-content');
    if (!next) throw Error(cfg.error);
    const contents = document.getElementById('BagContents');
    const previousScroll = contents.querySelector('.cart-lines')?.scrollTop || 0;
    const previousProgress = contents.querySelector('[data-shipping-progress]');
    const previous = {subtotal:Number(previousProgress?.dataset.subtotal || 0),count:document.querySelector('[data-cart-count]')?.textContent};
    contents.replaceChildren(next);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = next.dataset.cartCountValue || '0'; });
    const pageCart = document.querySelector('#MainContent .cart-content');
    if (pageCart) {
      const pageContents = next.cloneNode(true);
      pageContents.querySelector('.nz-cart-recommendations')?.remove();
      pageCart.replaceWith(pageContents);
    }
    renderDiscounts(cartState);
    window.NuzzlinoMotion?.cart(previous);
    const lines = contents.querySelector('.cart-lines');
    if (lines) lines.scrollTop = previousScroll;
    if (focus) {
      const root = focus.drawer ? bag : document.getElementById('MainContent');
      const row = [...root.querySelectorAll('[data-key]')].find(el => el.dataset.key === focus.key);
      const target = row?.querySelector(focus.selector) || root.querySelector('[name=checkout]') || root.querySelector('.empty-bag a') || bag.querySelector('[data-close]');
      target?.focus({ preventScroll: true });
    }
  }
  async function readDiscountCart() {
    const response = await fetch(`${cfg.cart.replace(/\/$/, '')}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw Error(cfg.error);
    return response.json();
  }
  const discountText = panel => JSON.parse(panel.querySelector('[data-discount-messages]').textContent);
  const discountMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  function discountStatus(panel, text, error = false) {
    const status = panel.querySelector('[data-discount-status]');
    status.textContent = text; status.hidden = !text; status.dataset.error = String(error);
    panel.querySelector('[data-discount-input]').setAttribute('aria-invalid', String(error));
  }
  function renderDiscounts(cart) {
    document.querySelectorAll('[data-cart-discount]').forEach(panel => {
      const text = discountText(panel), list = panel.querySelector('[data-discount-codes]');
      panel.hidden = false; list.replaceChildren();
      const codes = cart.discount_codes || [];
      for (const entry of codes) {
        const li = document.createElement('li'); li.className = 'nz-cart-discount-code';
        li.dataset.applicable = String(entry.applicable);
        const label = document.createElement('span'); label.textContent = entry.code;
        const value = document.createElement('span'); value.className = 'nz-cart-discount-value';
        const sameCode = application => application.type === 'discount_code' && application.title.toUpperCase() === entry.code.toUpperCase();
        let amount = (cart.cart_level_discount_applications || []).filter(sameCode).reduce((sum, application) => sum + application.total_allocated_amount, 0);
        for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) {
          if (sameCode(allocation.discount_application)) amount += allocation.amount;
        }
        value.textContent = entry.applicable ? (amount > 0 ? `−${discountMoney(amount, cart.currency)}` : text.active) : text.notApplied;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'nz-cart-discount-remove';
        remove.dataset.discountRemove = entry.code; remove.setAttribute('aria-label', text.remove.replace('[code]', entry.code));
        remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
        li.append(label, value, remove); list.append(li);
      }
      list.hidden = !codes.length;
      // The chips above replace only code allocations; keep native automatic discounts visible.
      panel.closest('.cart-summary').querySelectorAll('[data-cart-discount-allocation]').forEach(row => { row.hidden = row.dataset.discountType === 'discount_code' && codes.some(code => code.applicable); });
      const rejected = codes.find(code => !code.applicable);
      let warning = '';
      if (rejected) {
        const missing = 7500 - cart.items_subtotal_price;
        warning = rejected.code.toUpperCase() === 'NUZZL5' && cart.currency === 'USD' && missing > 0
          ? text.minimum.replace('[amount]', discountMoney(missing, cart.currency)) : text.invalid;
      }
      discountStatus(panel, warning, !!rejected);
    });
  }
  async function updateDiscount(control, removeCode) {
    if (cartBusy) return;
    const panel = control.closest('[data-cart-discount]'), input = panel.querySelector('[data-discount-input]');
    const text = discountText(panel), code = input.value.trim();
    const root = panel.closest('#BagDialog') ? bag : document.getElementById('MainContent');
    if (removeCode === undefined && !code) { discountStatus(panel, text.empty, true); input.focus(); return; }
    setCartBusy(true); discountStatus(panel, '');
    let notice = '', failed = false;
    try {
      const current = await readDiscountCart();
      const codes = (current.discount_codes || []).map(entry => entry.code);
      const next = removeCode !== undefined ? codes.filter(value => value.toUpperCase() !== removeCode.toUpperCase())
        : [...(current.discount_codes || []).filter(entry => entry.applicable && entry.code.toUpperCase() !== code.toUpperCase()).map(entry => entry.code), code];
      const result = await cartRequest(`${cfg.cart.replace(/\/$/, '')}/update.js`, { discount: next.join(',') });
      const accepted = result.discount_codes?.some(entry => entry.code.toUpperCase() === code.toUpperCase() && entry.applicable);
      await getBag();
      const updated = root.querySelector('[data-cart-discount]');
      if (updated) {
        if (removeCode !== undefined) notice = text.removed;
        else if (accepted) notice = text.applied;
        else { failed = true; notice = updated.querySelector('[data-discount-status]').textContent || text.invalid; updated.querySelector('[data-discount-input]').value = code; }
        discountStatus(updated, notice, failed); message(notice);
      }
    } catch {
      failed = true; notice = text.error;
      const current = root.querySelector('[data-cart-discount]');
      if (current) { current.querySelector('[data-discount-input]').value = code; discountStatus(current, notice, true); }
      message(notice);
    } finally {
      setCartBusy(false);
      const updated = root.querySelector('[data-cart-discount]');
      updated?.querySelector(failed || removeCode !== undefined ? '[data-discount-input]' : '[data-discount-apply]')?.focus({ preventScroll: true });
    }
  }
  // Cart-page initial state; drawer and subsequent quantity changes use getBag().
  if (document.querySelector('[data-cart-discount]')) {
    const version = cartRenderVersion;
    readDiscountCart().then(cart => { if (!cartBusy && version === cartRenderVersion) renderDiscounts(cart); }).catch(() => {});
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) {
      event.preventDefault(); updateDiscount(event.target);
    }
  });
  async function changeCart(line, amount, control) {
    if (cartBusy) return;
    const form = line.closest('form');
    const focus = { key: line.dataset.key, drawer: !!line.closest('#BagDialog'), selector: control?.matches('[data-cart-quantity]') ? '[data-cart-quantity]' : control?.matches('[data-cart-step="-1"]') ? '[data-cart-step="-1"]' : '[data-cart-step="1"]' };
    setCartBusy(true);
    try {
      await cartRequest(`${cfg.change}.js`, { id: line.dataset.key, quantity: amount });
      await getBag(focus);
      message(cfg.updated || cfg.added);
    } catch (error) { report(form, error.message); }
    finally { setCartBusy(false); }
  }
  function namespaceIds(root) {
    root.querySelectorAll('[id]').forEach(el => { el.id = `Quick-${el.id}`; });
    root.querySelectorAll('[for],[form],[data-media-target],[aria-labelledby],[aria-describedby],[aria-controls]').forEach(el => {
      for (const attr of ['for', 'form', 'data-media-target', 'aria-labelledby', 'aria-describedby', 'aria-controls']) {
        if (el.hasAttribute(attr)) el.setAttribute(attr, el.getAttribute(attr).split(/\s+/).map(id => `Quick-${id}`).join(' '));
      }
    });
  }
  async function quickView(target) {
    quickRequest?.abort();
    const request = new AbortController();
    quickRequest = request;
    target.classList.add('loading');
    try {
      const url = new URL(target.href, location.origin);
      url.searchParams.set('section_id', 'main-product');
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw Error(cfg.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-product-section]');
      if (!content) throw Error(cfg.error);
      let dialog = document.getElementById('QuickDialog');
      if (!dialog) {
        dialog = document.createElement('dialog'); dialog.id = 'QuickDialog'; dialog.className = 'quick-dialog'; document.body.append(dialog);
      }
      dialog.setAttribute('aria-label', content.querySelector('h1')?.textContent || target.textContent);
      const button = document.createElement('button');
      button.className = 'dialog-x'; button.type = 'button'; button.dataset.close = ''; button.textContent = '×';
      button.setAttribute('aria-label', bag.querySelector('[data-close]').getAttribute('aria-label'));
      namespaceIds(content);
      dialog.replaceChildren(button, content);
      initGallery(content);
      open(dialog, target);
    } catch (error) { if (error.name !== 'AbortError') location.href = target.href; }
    finally { target.classList.remove('loading'); }
  }
  async function quickAdd(target) {
    if (cartBusy || target.dataset.busy) return;
    const card = target.closest('.product-card'), fromBag = bag.contains(target);
    const index = [...bag.querySelectorAll('.nz-carousel-action')].indexOf(target);
    const error = card.querySelector('.form-error');
    if (error) error.hidden = true;
    target.dataset.busy = 'true'; target.setAttribute('aria-busy', 'true'); target.setAttribute('aria-disabled', 'true');
    setCartBusy(true); message(cfg.loading);
    try {
      await cartRequest(`${cfg.add}.js`, {items: [{id: Number(target.dataset.variantId), quantity: Number(target.dataset.quantity) || 1}]});
      if (!cfg.cartDrawer) { location.href = cfg.cart; return; }
      try {
        await getBag();
        open(bag, target);
        if (fromBag) {
          const actions = [...bag.querySelectorAll('.nz-carousel-action')];
          (actions[Math.min(index, actions.length - 1)] || bag.querySelector('[name=checkout]'))?.focus({preventScroll:true});
        }
        message(cfg.added);
      } catch { location.href = cfg.cart; }
    } catch (error) { report(card, error.message); }
    finally {
      delete target.dataset.busy; target.removeAttribute('aria-busy'); target.removeAttribute('aria-disabled'); setCartBusy(false);
    }
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('#C03Menu a')) { close(target.closest('dialog'), true); return; }
    if (target.matches('[data-open-dialog]')) { event.preventDefault(); open(document.getElementById(target.dataset.openDialog), target); target.setAttribute('aria-expanded', 'true'); return; }
    if (target.matches('[data-close]')) { close(target.closest('dialog')); return; }
    if (target.matches('[data-open-bag]') && cfg.cartDrawer) {
      event.preventDefault();
      if (cartBusy) { message(cfg.loading); return; }
      try { await getBag(); open(bag, target); } catch { location.href = cfg.cart; }
      return;
    }
    if (target.matches('[data-quantity-step]')) {
      const input = target.closest('.quantity-control').querySelector('input');
      input.value = quantity(input, Number(input.value) + Number(target.dataset.quantityStep) * (Number(input.step) || 1)); return;
    }
    if (target.matches('[data-discount-apply],[data-discount-remove]')) {
      event.preventDefault(); await updateDiscount(target, target.dataset.discountRemove); return;
    }
    if (target.matches('[data-cart-step],[data-remove]')) {
      event.preventDefault();
      const line = target.closest('[data-key]'), input = line.querySelector('[data-cart-quantity]');
      const amount = target.matches('[data-remove]') ? 0 : quantity(input, Number(input.value) <= Number(input.min) && Number(target.dataset.cartStep) < 0 ? 0 : Number(input.value) + Number(target.dataset.cartStep) * (Number(input.step) || 1), true);
      await changeCart(line, amount, target); return;
    }
    if (target.matches('[data-media-target],[data-gallery-step]')) {
      const gallery=target.closest('.gallery'), slides=[...gallery.querySelectorAll('.media-slide')];
      galleryNavigate(gallery,target.hasAttribute('data-media-target')?slides.findIndex(slide=>slide.id===target.dataset.mediaTarget):Number(gallery.dataset.index)+Number(target.dataset.galleryStep)); return;
    }
    if (target.matches('[data-quick-add]')) { event.preventDefault(); await quickAdd(target); return; }
    if (target.matches('[data-quick-view]')) { event.preventDefault(); if (!cartBusy) await quickView(target); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('.cart-form') && cartBusy) { event.preventDefault(); message(cfg.loading); return; }
    if (!form.matches('[data-product-form]')) return;
    event.preventDefault();
    event.stopPropagation();
    if (cartBusy || form.dataset.busy || form.closest('[data-product-section]').dataset.selectionReady === 'false') return;
    const button = form.querySelector('.add-button');
    if (button.disabled) return;
    const submitter = event.submitter || document.activeElement;
    const controls = [...form.querySelectorAll('button,input,select,fieldset')].map(control => [control, control.disabled]);
    form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy','true'); message(cfg.loading); setCartBusy(true);
    const error = form.querySelector('.form-error'); if (error) error.hidden = true;
    try {
      const data = new FormData(form);
      data.delete('form_type'); data.delete('utf8');
      [...data.keys()].filter(key => key.startsWith('option-')).forEach(key => data.delete(key));
      controls.forEach(([control]) => { control.disabled = true; });
      const response = await fetch(`${cfg.add}.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw Error(result.description || result.message || cfg.error);
      if (!cfg.cartDrawer) { location.href = cfg.cart; return; }
      try {
        await getBag();
        const quick = form.closest('dialog'), returnFocus = quick?.returnFocus || submitter;
        if (quick) await close(quick);
        open(bag, returnFocus); message(cfg.added);
      } catch { location.href = cfg.cart; }
    } catch (error) { report(form, error.message); }
    finally { delete form.dataset.busy; button.removeAttribute('aria-busy'); controls.forEach(([control, disabled]) => { control.disabled = disabled; }); setCartBusy(false); }
  }, true);
  function variantChoice(section) {
    const variants = JSON.parse(section.querySelector('[data-variant-data]')?.textContent || '[]');
    const groups = [...section.querySelectorAll('[data-option-position]')];
    const choices = groups.map(group => ({ position: Number(group.dataset.optionPosition), value: group.querySelector('input[data-option-value]:checked')?.dataset.optionLabel }));
    const matches = variants.filter(variant => choices.every(choice => !choice.value || variant.options[choice.position] === choice.value));
    return { matches, complete: choices.every(choice => choice.value), groups };
  }
  function availabilityState(section, state) {
    const box = section.querySelector('.availability');
    if (!box) return;
    const status = box.querySelector('[data-availability-state]');
    const text = box.querySelector('[data-availability-text]');
    if (status) status.dataset.availabilityState = state;
    if (text) text.textContent = box.dataset[`${state}Text`] || box.dataset.unavailableText;
    const sku = box.querySelector('[data-availability-sku]');
    if (sku) sku.hidden = true;
  }
  function galleryNavigate(gallery, index) {
    gallerySelect(gallery, index);
    selectImageVariant(gallery);
  }
  function selectImageVariant(gallery) {
    const section = gallery.closest('[data-product-section]');
    const media = gallery.querySelector('.media-slide.is-active')?.id.split('-').at(-1);
    if (!section || !media) return;
    section.dataset.gallerySelection = media;
    const variants = JSON.parse(section.querySelector('[data-variant-data]')?.textContent || '[]');
    const candidates = variants.filter(variant => String(variant.media) === media);
    if (!candidates.length) return;
    const groups = [...section.querySelectorAll('[data-option-position]')];
    const values = groups.map(group => {
      const position = Number(group.dataset.optionPosition);
      const fixed = candidates.every(variant => variant.options[position] === candidates[0].options[position]);
      return { group, position, fixed, value: fixed ? candidates[0].options[position] : group.querySelector('input[data-option-value]:checked')?.dataset.optionLabel };
    });
    if (!candidates.some(variant => values.every(choice => !choice.value || variant.options[choice.position] === choice.value))) {
      values.forEach(choice => { if (!choice.fixed) choice.value = undefined; });
    }
    let changed = false;
    values.forEach(({ group, value }) => {
      const radios = [...group.querySelectorAll('input[data-option-value]')];
      const previous = radios.find(input => input.checked)?.dataset.optionLabel;
      if (previous !== value) changed = true;
      radios.forEach(input => { input.checked = input.dataset.optionLabel === value; });
      const select = group.querySelector('[data-option-select]');
      if (select) { select.value = radios.find(input => input.checked)?.value || ''; updateOptionCaption(group); }
    });
    if (changed || (section.dataset.selectionReady !== 'true' && !section.hasAttribute('aria-busy') && variantChoice(section).complete)) selectVariant(section, gallery.querySelector('[aria-pressed="true"]'), true);
  }
  function pendingChoice(section, updateMedia = false) {
    const state = variantChoice(section);
    if (state.complete && state.matches.length) return state;
    const text = state.matches.length ? section.dataset.chooseOptions : section.dataset.unavailable;
    section.dataset.selectionReady = 'false';
    section.querySelectorAll('[data-option-details]').forEach(panel => { panel.hidden = true; });
    const id = section.querySelector('[name=id]'); id.value = ''; id.disabled = true;
    section.querySelectorAll('.add-button,.sticky-purchase button').forEach(button => { button.disabled = true; button.textContent = text; });
    availabilityState(section, state.matches.length && !state.complete ? 'pending' : 'unavailable');
    state.groups.forEach(group => { const hint = group.querySelector('[data-choice-hint]'); if (hint) hint.hidden = !!group.querySelector('input[data-option-value]:checked'); });
    const priced = [...state.matches].sort((a, b) => a.price - b.price);
    if (priced.length) {
      const low = priced[0], high = priced.at(-1);
      const price = low.price === high.price ? low.formattedPrice : `${low.formattedPrice} – ${high.formattedPrice}`;
      section.querySelector('.price-line').textContent = price;
      const sticky = section.querySelector('.sticky-purchase span');
      if (sticky) sticky.textContent = `${section.querySelector('h1').textContent} · ${price}`;
    }
    if (updateMedia) {
      const candidate = state.matches.find(variant => variant.available && variant.media) || state.matches.find(variant => variant.media);
      if (candidate) {
        const gallery = section.querySelector('.gallery');
        const slides = [...gallery.querySelectorAll('.media-slide')];
        gallerySelect(gallery, slides.findIndex(slide => slide.id.endsWith(`-${candidate.media}`)));
      }
    }
    return state;
  }
  async function selectVariant(section, target, fromGallery = false) {
    selections.get(section)?.abort();
    section.classList.remove('loading'); section.removeAttribute('aria-busy');
    if (!fromGallery) delete section.dataset.gallerySelection;
    const state = pendingChoice(section, !fromGallery);
    if (!state.complete || !state.matches.length) {
      if (!section.closest('dialog')) { const page = new URL(location.href); page.searchParams.delete('variant'); page.searchParams.delete('option_values'); history.replaceState({}, '', page); }
      return;
    }
    availabilityState(section, state.matches[0].available ? 'checking' : 'unavailable');
    const request = new AbortController(); selections.set(section, request);
    const focusId = target.id, previousQuantity = section.querySelector('[name=quantity]').value;
    section.dataset.selectionReady = 'false'; section.classList.add('loading'); section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('.add-button,.sticky-purchase button').forEach(button => { button.disabled = true; });
    try {
      const url = new URL(section.dataset.productUrl, location.origin);
      url.searchParams.set('variant', state.matches[0].id); url.searchParams.set('section_id', section.dataset.productSection);
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw Error(cfg.selectionError || cfg.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-product-section]');
      if (!next) throw Error(cfg.selectionError || cfg.error);
      if (selections.get(section) !== request) return;
      const inDialog = !!section.closest('dialog');
      if (inDialog) namespaceIds(next);
      const galleryHadFocus = section.querySelector('.gallery')?.contains(document.activeElement);
      const sizeGuideOpen = section.querySelector('[data-size-guide]')?.open;
      for (const selector of ['.gallery', '.price-line', '.variant-options', '.availability', '.sticky-purchase']) {
        const current = section.querySelector(selector), replacement = next.querySelector(selector);
        if (current && replacement) {
          if (selector === '.gallery') {
            const currentSlides = [...current.querySelectorAll('.media-slide')];
            const nextSlides = [...replacement.querySelectorAll('.media-slide')];
            if (currentSlides.length === nextSlides.length && currentSlides.every((slide, index) => slide.id === nextSlides[index].id)) {
              if (!fromGallery) gallerySelect(current, nextSlides.findIndex(slide => slide.classList.contains('is-active')));
              continue;
            }
            cancelGalleryFade(current);
          }
          if (selector === '.availability') current.innerHTML = replacement.innerHTML;
          else current.replaceWith(replacement);
        }
      }
      const form = section.querySelector('[data-product-form]'), id = form.querySelector('[name=id]'), nextId = next.querySelector('[name=id]');
      id.innerHTML = nextId.innerHTML; id.value = nextId.value; id.disabled = nextId.disabled;
      const add = form.querySelector('.add-button'), nextAdd = next.querySelector('.add-button');
      add.disabled = nextAdd.disabled; add.textContent = nextAdd.textContent;
      const qty = form.querySelector('[name=quantity]'), nextQty = next.querySelector('[name=quantity]');
      for (const attr of ['min', 'max', 'step']) { if (nextQty.hasAttribute(attr)) qty.setAttribute(attr, nextQty.getAttribute(attr)); else qty.removeAttribute(attr); }
      qty.value = quantity(qty, Number(previousQuantity));
      section.dataset.selectionReady = 'true'; form.querySelector('.form-error').hidden = true;
      initGallery(section); observeSticky();
      if (sizeGuideOpen && section.querySelector('[data-size-guide]')) section.querySelector('[data-size-guide]').open = true;
      if (galleryHadFocus && section.dataset.gallerySelection) section.querySelector(`[data-media-target$="-${section.dataset.gallerySelection}"]`)?.focus({ preventScroll: true });
      else if (focusId) section.querySelector(`#${CSS.escape(focusId)}`)?.focus({ preventScroll: true });
      if (!inDialog) { const page = new URL(location.href); page.searchParams.delete('option_values'); if (id.value) page.searchParams.set('variant', id.value); else page.searchParams.delete('variant'); history.replaceState({}, '', page); }
      id.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (error) { if (error.name !== 'AbortError') { availabilityState(section, 'error'); report(section, cfg.selectionError || error.message); } }
    finally { if (selections.get(section) === request) { section.classList.remove('loading'); section.removeAttribute('aria-busy'); } }
  }
  document.addEventListener('change', async event => {
    const target = event.target;
    if (target.matches('[data-sort]')) { target.form.requestSubmit(); return; }
    if (target.matches('[data-cart-quantity]')) {
      if (!target.value || !Number.isFinite(Number(target.value))) { report(target.form, cfg.quantityError || cfg.error); return; }
      await changeCart(target.closest('[data-key]'), quantity(target, Number(target.value)), target); return;
    }
    if (target.matches('.cart-form textarea[name=note]')) {
      if (cartBusy) return;
      setCartBusy(true);
      try { await cartRequest(`${cfg.cart.replace(/\/$/, '')}/update.js`, { note: target.value }); }
      catch { report(target.form, cfg.noteError || cfg.error); }
      finally { setCartBusy(false); }
      return;
    }
    if (target.matches('[data-option-select]')) {
      const group = target.closest('[data-option-position]');
      const radio = [...group.querySelectorAll('input[data-option-value]')].find(input => input.value === target.value);
      if (!radio) return;
      radio.checked = true; updateOptionCaption(group);
      await selectVariant(target.closest('[data-product-section]'), target); return;
    }
    if (target.matches('[data-option-value]')) await selectVariant(target.closest('[data-product-section]'), target);
  });
  function updateOptionCaption(group) {
    const select = group.querySelector('[data-option-select]');
    if (!select) return;
    const label = select.selectedOptions[0]?.textContent || '';
    const caption = group.querySelector('[data-option-caption]');
    select.title = select.value ? label : '';
    caption.textContent = select.value ? label : '';
    caption.hidden = !select.value || label.length <= 32;
  }
  function compactOptions(root) {
    root.querySelectorAll('[data-option-position]').forEach(group => {
      if (group.dataset.optionPresentation) return;
      const radios = [...group.querySelectorAll('input[data-option-value]')];
      const buttons = group.querySelector('.option-buttons');
      if (!radios.length || !buttons) return;
      const labels = radios.map(input => input.dataset.optionDisplay || input.dataset.optionLabel || '');
      if (radios.length === 1 && radios[0].checked) {
        group.dataset.optionPresentation = 'single';
        const value = document.createElement('p'); value.className = 'nz-option-single'; value.textContent = labels[0];
        buttons.hidden = true; group.append(value); return;
      }
      const compact = radios.length > 6 || labels.some(label => label.length > 24) || labels.join('').length > 90;
      group.dataset.optionPresentation = compact ? 'select' : 'buttons';
      if (!compact) {
        group.dataset.optionLayout = labels.every(label => label.trim().length <= 10) ? 'short' : 'grid';
        return;
      }
      const select = document.createElement('select'); select.className = 'nz-option-select'; select.dataset.optionSelect = '';
      select.id = `Select-${radios[0].id}`;
      const legend = group.querySelector('legend'); legend.id = `Legend-${radios[0].id}`;
      select.setAttribute('aria-labelledby', legend.id);
      select.required = group.hasAttribute('data-requires-choice');
      const placeholder = document.createElement('option'); placeholder.value = ''; placeholder.disabled = true;
      placeholder.textContent = group.closest('[data-product-section]').dataset.chooseOptions;
      select.append(placeholder);
      for (const radio of radios) {
        const option = document.createElement('option'); option.value = radio.value; option.textContent = radio.dataset.optionDisplay || radio.dataset.optionLabel;
        select.append(option);
      }
      select.value = radios.find(input => input.checked)?.value || '';
      const caption = document.createElement('p'); caption.className = 'nz-option-caption'; caption.dataset.optionCaption = '';
      caption.id = `Caption-${radios[0].id}`; select.setAttribute('aria-describedby', caption.id);
      buttons.hidden = true; group.append(select, caption); updateOptionCaption(group);
    });
  }
  function initGallery(root) {
    compactOptions(root);
    const products = [...root.querySelectorAll('[data-product-section]')];
    if (root.matches?.('[data-product-section]')) products.push(root);
    products.forEach(section => { if (section.querySelector('[data-variant-data]')) pendingChoice(section); });
    root.querySelectorAll('.variant-options').forEach(el => { el.hidden = false; });
    root.querySelectorAll('.native-variant-fallback').forEach(el => { el.hidden = true; });
    root.querySelectorAll('.option-buttons').forEach(group => group.classList.toggle('long-options', [...group.querySelectorAll('label')].some(label => label.textContent.trim().length > 18)));
    root.querySelectorAll('.gallery-stage').forEach(initGalleryStage);
  }
  // Gallery state belongs to the rendered section, so variant replacements start cleanly.
  function cancelGalleryFade(gallery) {
    galleryFades.get(gallery)?.();
  }
  function fadeGalleryImage(gallery, previous, active) {
    const outgoing = previous?.querySelector('.media-image img');
    const incoming = active.querySelector('.media-image img');
    if (!outgoing?.complete || !outgoing.naturalWidth || !incoming || reduceMotion()) return false;
    cancelGalleryFade(gallery);
    const layer = document.createElement('div');
    layer.className = 'gallery-image-fade';
    layer.setAttribute('aria-hidden', 'true');
    layer.inert = true;
    const image = outgoing.cloneNode(false);
    image.removeAttribute('id');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = outgoing.currentSrc || outgoing.src;
    image.alt = '';
    image.loading = 'eager';
    layer.append(image);
    gallery.querySelector('.gallery-frame').append(layer);
    let animation, timer;
    const cleanup = () => {
      clearTimeout(timer);
      animation?.cancel();
      layer.remove();
      if (galleryFades.get(gallery) === cleanup) galleryFades.delete(gallery);
    };
    galleryFades.set(gallery, cleanup);
    timer = setTimeout(cleanup, 5000);
    incoming.loading = 'eager';
    incoming.decode().catch(() => {}).then(() => {
      if (galleryFades.get(gallery) !== cleanup) return;
      if (!gallery.isConnected || reduceMotion() || !incoming.naturalWidth) { cleanup(); return; }
      animation = layer.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 520, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' });
      animation.finished.then(cleanup, () => {});
    });
    return true;
  }
  function gallerySelect(gallery, index, scroll = true, instant = false) {
    const stage = gallery.querySelector('.gallery-stage');
    const slides = [...stage.querySelectorAll('.media-slide')];
    if (!slides.length) return;
    index = Math.max(0, Math.min(slides.length - 1, index));
    const active = slides[index];
    const previous = stage.querySelector('.media-slide.is-active');
    if (instant || reduceMotion()) cancelGalleryFade(gallery);
    const fade = scroll && !instant && previous !== active && Math.abs((previous?.offsetLeft || 0) - stage.scrollLeft) < 2 && fadeGalleryImage(gallery, previous, active);
    if (scroll && previous !== active && !fade) cancelGalleryFade(gallery);
    if (scroll && Math.abs(active.offsetLeft-stage.scrollLeft)>.5) stage.classList.add('is-moving');
    const changed = Number(gallery.dataset.index) !== index;
    gallery.dataset.index = index;
    slides.forEach(slide => {
      slide.classList.toggle('is-active', slide === active);
      slide.inert = slide !== active;
      if (slide !== active) {
        slide.querySelectorAll('video').forEach(video => video.pause());
        slide.querySelectorAll('iframe').forEach(frame => {
          // Stop supported external players without reloading or starting playback.
          if (/youtube\.com|youtube-nocookie\.com/.test(frame.src)) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), new URL(frame.src).origin);
          if (/player\.vimeo\.com/.test(frame.src)) frame.contentWindow?.postMessage({method:'pause'}, new URL(frame.src).origin);
        });
        slide.querySelector('model-viewer')?.pause?.();
      }
    });
    gallery.querySelectorAll('[data-media-target]').forEach(button => {
      const selected = button.dataset.mediaTarget === active.id;
      button.setAttribute('aria-pressed', String(selected));
      if (selected && (changed || instant)) {
        const strip = button.parentElement;
        const left = button.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + button.offsetWidth > strip.scrollLeft + strip.clientWidth)
          strip.scrollTo({ left: left - (strip.clientWidth - button.offsetWidth) / 2, behavior: instant || reduceMotion() ? 'instant' : 'smooth' });
      }
    });
    const counter = gallery.querySelector('[data-gallery-count]');
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    gallery.querySelectorAll('[data-gallery-step]').forEach(button => {
      button.hidden = slides.length < 2;
      button.disabled = Number(button.dataset.galleryStep) < 0 ? index === 0 : index === slides.length - 1;
    });
    gallery.querySelector('.gallery-thumbnails').hidden = slides.length < 2;
    if (scroll) stage.scrollTo({ left: active.offsetLeft, behavior: fade || instant || reduceMotion() || Math.abs(stage.scrollLeft - active.offsetLeft) > stage.clientWidth * 1.5 ? 'instant' : 'smooth' });
    if (scroll) stage.dispatchEvent(new Event('nz:gallery-settle'));
    // Align painted content as well as scroll positions at fractional browser zoom levels.
    const frameRect=stage.getBoundingClientRect(), activeRect=active.getBoundingClientRect();
    const correction=frameRect.left-activeRect.left;
    stage.style.setProperty('--gallery-pixel-offset',activeRect.width && Math.abs(correction)<2 ? `${correction/activeRect.width*100}%` : '0%');
    // Only the current and adjacent image are promoted; long supplier galleries stay lazy.
    [active, slides[index + 1]].forEach(slide => {
      const img = slide?.querySelector('img');
      if (img) img.loading = 'eager';
    });
  }
  function initThumbnailDrag(strip) {
    if (!strip || strip.dataset.dragInit) return;
    strip.dataset.dragInit='true';
    strip.querySelectorAll('img').forEach(img=>{img.draggable=false;});
    const availability=()=>{strip.dataset.dragScroll=String(strip.scrollWidth>strip.clientWidth+1);};
    strip.addEventListener('pointerenter',availability);
    requestAnimationFrame(availability);
    let drag, suppressClickUntil=0;
    strip.addEventListener('pointerdown',event=>{
      if(event.pointerType!=='mouse'||event.button!==0||strip.scrollWidth<=strip.clientWidth+1)return;
      drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:strip.scrollLeft,active:false};
    });
    strip.addEventListener('pointermove',event=>{
      if(!drag||drag.id!==event.pointerId)return;
      const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
      if(!drag.active){
        if(Math.abs(dx)<6||Math.abs(dx)<Math.abs(dy))return;
        drag.active=true;strip.classList.add('is-dragging');strip.setPointerCapture(event.pointerId);
      }
      event.preventDefault();strip.scrollTo({left:drag.left-dx,behavior:'instant'});
    });
    const end=event=>{
      if(!drag||drag.id!==event.pointerId)return;
      const last=drag;drag=undefined;
      if(last.active)suppressClickUntil=Date.now()+450;
      strip.classList.remove('is-dragging');
      if(strip.hasPointerCapture(last.id))strip.releasePointerCapture(last.id);
    };
    strip.addEventListener('pointerup',end);
    strip.addEventListener('pointercancel',end);
    strip.addEventListener('lostpointercapture',end);
    strip.addEventListener('pointerleave',()=>{if(drag&&!drag.active)drag=undefined;});
    strip.addEventListener('click',event=>{if(Date.now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}},true);
  }
  function initGalleryStage(stage) {
    if (stage.dataset.init) return;
    stage.dataset.init = 'true';
    const gallery = stage.closest('.gallery');
    const slides = [...stage.querySelectorAll('.media-slide')];
    const requested = gallery.closest('[data-product-section]')?.dataset.gallerySelection;
    const initial = Math.max(0, slides.findIndex(slide => requested ? slide.id.endsWith(`-${requested}`) : slide.classList.contains('is-active')));
    gallery.querySelector('.gallery-toolbar').hidden = false;
    initThumbnailDrag(gallery.querySelector('.gallery-thumbs'));
    stage.querySelectorAll('img').forEach(img => { img.draggable = false; });
    let touchStart, touchNavigation = false, suppressClickUntil = 0, tick;
    stage.addEventListener('touchstart', event => { cancelGalleryFade(gallery); const t = event.touches[0]; touchStart = t ? {x:t.clientX,y:t.clientY} : null; stage.classList.add('is-moving'); }, {passive:true});
    stage.addEventListener('touchend', event => {
      const t = event.changedTouches[0];
      if (t && touchStart && Math.hypot(t.clientX-touchStart.x,t.clientY-touchStart.y)>10) {
        suppressClickUntil=Date.now()+450;
        touchNavigation = Math.abs(t.clientX-touchStart.x) > Math.abs(t.clientY-touchStart.y);
      }
      touchStart=null;
      scheduleGallerySettle();
    }, {passive:true});
    stage.dataset.draggable = String(slides.length > 1);
    let mouseDrag;
    stage.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || slides.length < 2 || !event.target.closest('.media-image')) return;
      cancelGalleryFade(gallery);
      mouseDrag = { id:event.pointerId, x:event.clientX, y:event.clientY, left:stage.scrollLeft, index:Number(gallery.dataset.index)||0, active:false };
    });
    stage.addEventListener('pointermove', event => {
      if (!mouseDrag || event.pointerId !== mouseDrag.id) return;
      const dx=event.clientX-mouseDrag.x, dy=event.clientY-mouseDrag.y;
      if (!mouseDrag.active) {
        if (Math.abs(dx)<8 || Math.abs(dx)<Math.abs(dy)) return;
        mouseDrag.active=true;
        clearTimeout(tick);
        stage.classList.add('is-dragging');
        stage.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      stage.scrollTo({left:mouseDrag.left-dx,behavior:'instant'});
    });
    function endMouseDrag(event) {
      if (!mouseDrag || event.pointerId!==mouseDrag.id) return;
      const drag=mouseDrag;mouseDrag=undefined;
      if (!drag.active) return;
      suppressClickUntil=Date.now()+450;
      stage.classList.remove('is-dragging');
      if (stage.hasPointerCapture(drag.id)) stage.releasePointerCapture(drag.id);
      const dx=event.clientX-drag.x;
      const step=event.type==='pointerup' && Math.abs(dx)>=Math.min(80,stage.clientWidth*.18) ? (dx<0?1:-1) : 0;
      if (step) galleryNavigate(gallery,drag.index+step);
      else gallerySelect(gallery,drag.index);
    }
    stage.addEventListener('pointerup',endMouseDrag);
    stage.addEventListener('pointercancel',endMouseDrag);
    stage.addEventListener('lostpointercapture',endMouseDrag);
    stage.addEventListener('pointerleave',()=>{if(mouseDrag && !mouseDrag.active)mouseDrag=undefined;});
    stage.addEventListener('click', event => { if (Date.now()<suppressClickUntil) { event.preventDefault();event.stopPropagation(); } }, true);
    function scheduleGallerySettle() {
      clearTimeout(tick);
      tick=setTimeout(() => {
        if (!mouseDrag?.active && stage.isConnected && stage.clientWidth) {
          gallerySelect(gallery,Math.round(stage.scrollLeft/stage.clientWidth),false);
          stage.classList.remove('is-moving');
          if (touchNavigation && !touchStart) { touchNavigation = false; selectImageVariant(gallery); }
        }
      },140);
    }
    stage.addEventListener('nz:gallery-settle',scheduleGallerySettle);
    stage.addEventListener('scroll', () => {
      stage.classList.add('is-moving');
      scheduleGallerySettle();
    }, {passive:true});
    gallery.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key) || event.target.closest('video,model-viewer,iframe')) return;
      event.preventDefault();
      let index = Number(gallery.dataset.index) || 0;
      index = event.key==='Home' ? 0 : event.key==='End' ? slides.length-1 : index+(event.key==='ArrowRight'?1:-1);
      galleryNavigate(gallery,index);
      if (event.target.closest('.media-slide')) stage.focus({preventScroll:true});
    });
    gallerySelect(gallery,initial,true,true);
    requestAnimationFrame(() => { if (stage.isConnected) gallerySelect(gallery,initial,true,true); });
  }
  function headerBottom() {
    return Math.max(0, ...[...document.querySelectorAll('.shopify-section-group-header-group')].map(el => Math.max(0, el.getBoundingClientRect().bottom)));
  }
  function updateSticky() {
    const section = document.querySelector('#MainContent [data-product-section]'), bar = section?.querySelector('.sticky-purchase'), button = section?.querySelector('.purchase-row .add-button');
    if (!bar || !button) return;
    const r = button.getBoundingClientRect();
    bar.classList.toggle('visible', r.bottom <= headerBottom() + 1);
  }
  function observeSticky() {
    stickyObserver?.disconnect(); headerObserver?.disconnect();
    const button = document.querySelector('#MainContent .purchase-row .add-button');
    if (!button) return;
    const rebuild = () => {
      stickyObserver?.disconnect();
      stickyObserver = new IntersectionObserver(updateSticky, { rootMargin: `-${Math.ceil(headerBottom())}px 0px 0px 0px`, threshold: [0, 1] });
      stickyObserver.observe(button); updateSticky();
    };
    headerObserver = new ResizeObserver(rebuild);
    document.querySelectorAll('.shopify-section-group-header-group').forEach(el => headerObserver.observe(el)); rebuild();
  }
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = undefined; viewport(); updateSticky(); });
  }
  async function initRecommendations(root) {
    for (const section of root.querySelectorAll('[data-recommendations]:not([data-ready])')) {
      section.dataset.ready = 'true';
      try {
        const response = await fetch(section.dataset.recommendations);
        if (!response.ok) throw Error(cfg.error);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html'), next = doc.querySelector('.recommendations .product-grid');
        if (next?.children.length) section.querySelector('.product-grid').replaceWith(next); else section.hidden = true;
      } catch { section.hidden = true; }
    }
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab' && openDialogs().length) {
      const dialog = openDialogs().at(-1);
      const controls = [...dialog.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),summary,[tabindex]:not([tabindex="-1"])')].filter(el => el.tabIndex >= 0 && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert]'));
      const first = controls[0], last = controls.at(-1);
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      return;
    }
    if (event.key !== 'Escape' || openDialogs().length) return;
    const focused = document.activeElement;
    const branch = focused?.closest('details[open]');
    const menu = focused?.closest('.mobile-nav[open]');
    if (branch && branch !== menu) { branch.open = false; branch.querySelector('summary')?.focus(); event.preventDefault(); return; }
    const openMenus = [...document.querySelectorAll('.mobile-nav[open],.desktop-nav details[open]')];
    if (!openMenus.length) return;
    openMenus.forEach(el => { el.open = false; el.querySelectorAll('details[open]').forEach(child => { child.open = false; }); });
    (menu || openMenus[0]).querySelector('summary')?.focus(); event.preventDefault();
  });
  document.querySelectorAll('dialog').forEach(initDialog);
  initGallery(document); observeSticky(); initRecommendations(document);
  document.addEventListener('shopify:section:load', event => { initGallery(event.target); initRecommendations(event.target); observeSticky(); });
  document.addEventListener('shopify:section:unload', () => { requestAnimationFrame(observeSticky); });
  window.addEventListener('resize', () => {
    schedule();
    document.querySelectorAll('.gallery-stage[data-init]').forEach(stage => {const gallery=stage.closest('.gallery');gallerySelect(gallery,Number(gallery.dataset.index)||0,true,true);});
  }, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
})();

if (!customElements.get('nz-product-carousel')) {
  customElements.define('nz-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.track = this.querySelector('.nz-home-carousel__track');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.track.dataset.mouseDrag = String(end > 2);
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= end - 2;
      };
      const move = direction => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        const visible = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
        this.track.scrollBy({left: direction * step * visible, behavior: motion.matches ? 'instant' : 'smooth'});
      };
      this.buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), options));
      this.track.addEventListener('scroll', update, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      let drag, suppressClick = false;
      const endDrag = event => {
        if (!drag || (event && event.pointerId !== drag.id)) return;
        const previous = drag;
        drag = null;
        if (previous.active) suppressClick = true;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(previous.id)) this.track.releasePointerCapture(previous.id);
      };
      this.cancelDrag = () => endDrag();
      this.track.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.track.dataset.mouseDrag !== 'true') return;
        drag = {id:event.pointerId, x:event.clientX, y:event.clientY, left:this.track.scrollLeft, active:false};
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (!(event.buttons & 1)) { endDrag(event); return; }
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy)) return;
          drag.active = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollTo({left:drag.left - dx, behavior:'instant'});
      }, options);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.track.addEventListener(type, endDrag, options));
      this.track.addEventListener('pointerleave', () => { if (drag && !drag.active) endDrag(); }, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        suppressClick = false;
        event.preventDefault(); event.stopPropagation();
      }, {...options, capture:true});
      window.addEventListener('blur', this.cancelDrag, options);
      this.resize = new ResizeObserver(update); this.resize.observe(this.track);
      this.querySelector('.nz-home-carousel__controls').hidden = false; update();
    }
    disconnectedCallback() { this.cancelDrag?.(); this.abort?.abort(); this.abort = null; this.resize?.disconnect(); }
  });
}
